<template>
    <div class="select-wrapper">
        <el-select
            ref="el_select"
            :clearable="clearable"
            :disabled="disabled"
            v-model="Content"
            :multiple="multiple"
            :collapse-tags="collapseTags"
            :placeholder="disabled ? '' : placeholder"
            @change="onChange"
            @input="onInput"
            :filterable="filterable"
            :no-data-text="'Không có bản ghi nào'"
            :no-match-text="'Không tìm thấy bản ghi nào'"
            :size="size"
            :class="{
                'active-dislabel': disabled,
                'error-select': textError.length > 0
            }"
            :popper-class="popperClass"
            @visible-change="onVisibleChange"
        >
            <li
                style="border: 1px solid #e4e7ed"
                v-if="multiple"
                class="el-select-dropdown__item select-all-item"
            >
                <label class="select-all-label">
                    <input
                        type="checkbox"
                        @change="onCheckAllChange"
                        v-model="CheckAll"
                        class="select-all-checkbox"
                    />
                    <span class="select-all-text">--Tất cả--</span>
                </label>
            </li>
            <el-option
                v-for="(item, index) in data"
                :key="index"
                :label="getLabel(item)"
                :disabled="item.disabled"
                :value="getValue(item)"
            ></el-option>
        </el-select>
        <span v-if="textError.length > 0" class="text-error-input">
            {{ textError }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        clearable: {
            default: true
        },
        value: {
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        data: {
            type: Array,
            default: () => [],
            required: true
        },
        placeholder: {
            default: 'Chọn'
        },
        filterable: {
            type: Boolean,
            default: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
        'collapse-tags': {
            type: Boolean,
            default: true
        },
        fields: {
            type: Array,
            required: true
        },
        size: {
            type: String,
            default: 'medium'
        },
        textError: {
            type: String,
            default: ''
        }
    },
    watch: {
        value: {
            handler(newValue) {
                this.Content = newValue || (this.multiple ? [] : null)
                if (this.multiple && Array.isArray(this.Content)) {
                    this.CheckAll =
                        this.Content.length === (this.data ? this.data.length : 0)
                }
            },
            immediate: true
        },
        data: {
            handler() {
                if (this.multiple && Array.isArray(this.Content)) {
                    this.CheckAll =
                        this.Content.length === (this.data ? this.data.length : 0)
                }
            },
            immediate: true
        }
    },
    mounted() {},
    data() {
        return {
            Content: this.value,
            CheckAll: false
        }
    },
    computed: {
        popperClass() {
        let cls = 'e-select-dropdown-' + this._uid
        // Nếu đang chọn tất cả -> Thêm class đặc biệt để CSS hook vào
        if (this.CheckAll) {
            cls += ' mode-select-all'
        }
        return cls
    }
    },
    methods: {
        onCheckAllChange() {
            if (this.CheckAll) {
                this.Content = []
                if (this.fields[1]) {
                    this.data.forEach((obj) => {
                        this.Content.push(obj[this.fields[1]])
                    })
                }
                // Emit only once after all items are added
                this.$emit('input', this.Content)
                this.$emit('change', this.Content)
            } else {
                this.Content = []
                this.$emit('change', this.Content)
                this.$emit('input', this.Content)
            }
        },
        focus() {
            this.$refs.el_select.focus()
        },
        onChange(e) {
            if (this.Content.length == this.data.length) {
                this.CheckAll = true
            } else {
                this.CheckAll = false
            }
            this.$emit('change', e)
        },
        onInput(e) {
            this.$emit('input', e)
        },
        getLabel(item) {
            if (!this.fields[0]) {
                return
            }
            return item[this.fields[0]]
        },
        getValue(item) {
            if (!this.fields[1]) {
                return
            }
            return item[this.fields[1]]
        },

        /**
         * Ensure popper width matches the trigger width when the dropdown becomes visible.
         * Works for both body-appended poppers and inline poppers.
         */
        onVisibleChange(visible) {
            // run after DOM updates
            if (visible) {
                this.$nextTick(() => {
                    try {
                        const popper = document.querySelector(
                            '.' + this.popperClass
                        )
                        // trigger element for el-select
                        const trigger =
                            this.$refs.el_select && this.$refs.el_select.$el
                        if (popper && trigger) {
                            const rect = trigger.getBoundingClientRect()
                            // set explicit width in px so body-appended popper exactly matches trigger
                            popper.style.minWidth = rect.width + 'px'
                            popper.style.width = rect.width + 'px'
                            popper.style.boxSizing = 'border-box'
                            // ensure dropdown is above modal/backdrop
                            popper.style.zIndex = 20000

                            // make the list horizontally scrollable and prevent wrapping
                            const listWrap =
                                popper.querySelector(
                                    '.el-select-dropdown__wrap'
                                ) ||
                                popper.querySelector('.el-select-dropdown__list')
                            if (listWrap) {
                                listWrap.style.whiteSpace = 'nowrap'
                                listWrap.style.overflowX = 'auto'
                                listWrap.style.overflowY = 'auto' // keep vertical scroll if many items
                            }
                        }
                    } catch (err) {
                        // fail silently — this is best-effort
                        // console.warn('ESelect popper sizing failed', err)
                    }
                })
            } else {
                // cleanup inline styles (optional)
                const popper = document.querySelector('.' + this.popperClass)
                if (popper) {
                    popper.style.width = ''
                    popper.style.minWidth = ''
                    popper.style.boxSizing = ''
                    popper.style.zIndex = ''
                    const listWrap =
                        popper.querySelector('.el-select-dropdown__wrap') ||
                        popper.querySelector('.el-select-dropdown__list')
                    if (listWrap) {
                        listWrap.style.whiteSpace = ''
                        listWrap.style.overflowX = ''
                        listWrap.style.overflowY = ''
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
/* Fix checkbox alignment in select all option */
.select-all-item {
    padding: 0 !important;
}

.select-all-label {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 16px;
    width: 100%;
    height: 34px;
    font-weight: normal;
    margin: 0;
    cursor: pointer;
}

.select-all-checkbox {
    cursor: pointer;
    margin: 0;
    flex-shrink: 0;
    accent-color: var(--blue-200);
}

.select-all-text {
    flex: 1;
    line-height: 34px;
}

.el-select-dropdown__item {
    color: #212529 !important;
}

.el-select-dropdown__item:hover {
    color: var(--blue-200) !important;
    background: #f0f8ff !important;
}

/* Ensure dropdown options also have proper alignment */
::v-deep .el-select-dropdown__item {
    display: flex;
    align-items: center;
}

::v-deep .el-checkbox {
    display: flex;
    align-items: center;
}

::v-deep .el-checkbox__label {
    display: flex;
    align-items: center;
    line-height: 1;
}
</style>

<style>
    .el-select-dropdown.mode-select-all .el-select-dropdown__item.selected {
        background-color: #fff !important; /* Ghi đè thành nền trắng */
        color: var(--blue-200) !important; /* Chữ xanh */
        font-weight: 700 !important;
    }
    
    /* Đổi màu dấu tick sang xanh */
    .el-select-dropdown.mode-select-all .el-select-dropdown__item.selected::after {
        color: var(--blue-200) !important;
        font-weight: bold;
    }
    
    /* Hiệu ứng hover khi đang ở chế độ chọn tất cả */
    .el-select-dropdown.mode-select-all .el-select-dropdown__item.selected:hover {
        background-color: #f0f8ff !important; /* Màu xanh nhạt khi di chuột */
    }
    </style>
